import Client from "@/repositories/Client/AxiosClient.js"

const resource = `/api/appliances/person`

export default {
  list(id) {
    return Client.get(`${resource}/people/${id}`)
  },

  create(appliance) {
    return Client.post(
      `${resource}/${appliance.id}/people/${appliance.person_id}`,
      appliance,
    )
  },

  show(applianceId) {
    return Client.get(`${resource}/people/detail/${applianceId}`)
  },

  updateTotalCost(appliancePersonId, terms) {
    return Client.put(`${resource}/${appliancePersonId}/total-cost`, terms)
  },

  delete(appliancePersonId) {
    return Client.delete(`${resource}/${appliancePersonId}`)
  },
}
